<template lang="pug">
RollInfoPanel(ref="rollInfoPanel")
  .define-range
    .row
      .col-xs-12.col-sm-4
        .form-group
          label.light(for="start-code") Start code
          .start-code {{rollInfo.unassigned.first.code}}
      .col-xs-12.col-sm-8
        SplitPointSelect(
          :code="splitPointCode"
          :rollLastCode="rollInfo.last.code"
          :findRollCode="findRollCode" @submit="handleSplitPointSelection")
    .row
      .col-sm-10.col-sm-offset-1
        .alert.alert-info(v-if="loading") Loading...
        .alert.alert-danger(v-if="errorMsg") {{errorMsg}}
    .row(v-if="targetInfo")
      .col-xs-12
        .flex
          .flex-1.text-center
            span(style="color: blue")
              i.fa.fa-info-circle
              |  You have selected {{activationSize}} codes
          .btn-continue
            button.btn.btn-primary(@click="$emit('next')") Continue

</template>
<script>
import activationSession from '../service/ActivationSession'
import RollInfoPanel from '../components/RollInfoPanel'
import SplitPointSelect from '../components/SplitPointSelect'

export default {
  created() {
    this.rollInfo = activationSession.getRollInfo()
    this.findRollCode = activationSession.getCode()
    this.targetInfo = activationSession.getTargetInfo()
    if (this.targetInfo) {
      this.splitPointCode = this.targetInfo.targetCode.code
    }
  },
  data: () => ({
    findRollCode: '',
    splitPointCode: '',
    loading: false,
    errorMsg: null,
    rollInfo: null,
    targetInfo: null
  }),
  computed: {
    activationSize() {
      return this.calcActivationSize(this.targetInfo)
    }
  },
  methods: {
    calcActivationSize(targetInfo) {
      return (targetInfo.relativeRollCodeIndex - this.rollInfo.activeCodeCount) + 1
    },
    handleSplitPointSelection(code) {
      this.splitPointCode = code
      this.errorMsg = null
      this.targetInfo = null
      if (!this.splitPointCode) return

      this.loading = true
      activationSession.getRollTarget(this.splitPointCode)
        .then((resp) => {
          const targetInfo = resp.data

          const sameRoll = targetInfo.firstCode.code === this.rollInfo.first.code
            && targetInfo.lastCode.code === this.rollInfo.last.code;
          if (!sameRoll) {
            this.errorMsg = `Please scan a code from the same roll. Target code is not on the same lookup roll.
              Roll[${this.rollInfo.first.code}, ${this.rollInfo.last.code}],
              Target[${targetInfo.firstCode.code}, ${targetInfo.lastCode.code}]`
            return
          }

          if (this.calcActivationSize(targetInfo) <= 0) {
            this.errorMsg = `Invalid split point. Code must be in unnassigned section. Code index on the roll: ${targetInfo.relativeRollCodeIndex}`
            return
          }

          this.targetInfo = targetInfo

          this.$refs.rollInfoPanel.refresh()
        })
        .catch((e) => {
          if (e.response.status === 400) {
            this.errorMsg = e.response.data.message
          } else {
            this.$emit('error', e)
          }
        })
        .then(() => {
          this.loading = false
        })
    }
  },
  components: {
    RollInfoPanel,
    SplitPointSelect
  }
}
</script>

<style lang="scss">
.define-range {
  .start-code {
      background: #f6f6f6;
      border: 1px solid #d6d9dc;
      border-radius: 4px;
      height: 33px;
      line-height: 34px;
      padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/activator/wiz/DefineRange.vue